import React from 'react';
import { Box } from '@mui/material';
import { FILM_STRIP } from '../constants/memoriesVisualFilters';

/**
 * Film roll: half | full | half — left end shows the right of the photo,
 * right end shows the left (continuous strip cut at each edge).
 */
export default function MemoriesFilmStripFrames({
  src,
  imageSx = {},
  overlaySx = null,
  toneOverlaySx = null,
  mode = 'bg', // 'bg' | 'img'
  alt = '',
}) {
  const safeUrl = String(src || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  const cells = [
    { key: 'left', flex: 1, position: 'right center' },
    { key: 'center', flex: 2, position: 'center center' },
    { key: 'right', flex: 1, position: 'left center' },
  ];

  return (
    <Box
      data-testid="memories-film-strip-frames"
      sx={{
        display: 'flex',
        alignItems: 'stretch',
        gap: `${FILM_STRIP.frameGapPct || 3.5}%`,
        width: '100%',
        height: '100%',
        minHeight: 0,
        backgroundColor: 'transparent',
      }}
    >
      {cells.map((cell) => (
        <Box
          key={cell.key}
          sx={{
            position: 'relative',
            flex: `${cell.flex} 1 0`,
            minWidth: 0,
            overflow: 'hidden',
            border: `1px solid ${FILM_STRIP.frameEdge}`,
            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.2)',
            backgroundColor: '#111',
          }}
        >
          {mode === 'img' ? (
            <Box
              component="img"
              src={src}
              alt={cell.key === 'center' ? alt : ''}
              aria-hidden={cell.key !== 'center'}
              sx={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: cell.position,
                ...imageSx,
              }}
            />
          ) : (
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                backgroundImage: `url("${safeUrl}")`,
                backgroundSize: 'cover',
                backgroundPosition: cell.position,
                backgroundRepeat: 'no-repeat',
                ...imageSx,
              }}
            />
          )}
          {overlaySx && (
            <Box
              aria-hidden
              sx={{
                position: 'absolute',
                inset: 0,
                pointerEvents: 'none',
                ...overlaySx,
              }}
            />
          )}
          {toneOverlaySx && (
            <Box
              aria-hidden
              sx={{
                position: 'absolute',
                inset: 0,
                pointerEvents: 'none',
                ...toneOverlaySx,
              }}
            />
          )}
        </Box>
      ))}
    </Box>
  );
}
